import { Card, CardContent } from "@/components/ui/card";
import galleryCleaningImg from "@/assets/gallery-cleaning.jpg";
import galleryMovingImg from "@/assets/gallery-moving.jpg";
import galleryHandymanImg from "@/assets/gallery-handyman.jpg";
import galleryPlumbingImg from "@/assets/gallery-plumbing.jpg";
import galleryRenovationImg from "@/assets/gallery-renovation.jpg";

const Gallery = () => {
  const galleryItems = [
    {
      id: 1,
      image: galleryCleaningImg,
      title: "Siivouspalvelut / Cleaning Services",
      description: "Koti-, toimisto- ja syväsiivous / Home, office & deep cleaning",
      alt: "Professional cleaning service in modern office environment"
    },
    {
      id: 2,
      image: galleryMovingImg,
      title: "Muuttopalvelut / Moving Services", 
      description: "Paikalliset ja kaukomuutot / Local & long-distance moving",
      alt: "Professional moving team carrying furniture with organized truck"
    },
    {
      id: 3,
      image: galleryHandymanImg,
      title: "Käsityöpalvelut / Handyman Services",
      description: "Seinäkorjaukset ja asennukset / Wall repairs & installations", 
      alt: "Professional handyman doing wall repairs in modern home"
    },
    {
      id: 4,
      image: galleryPlumbingImg,
      title: "LVI-palvelut / Plumbing Services",
      description: "Pesukoneen ja astianpesukoneen asennus / Appliance installation",
      alt: "Professional plumber installing washing machine in modern kitchen"
    },
    {
      id: 5,
      image: galleryRenovationImg,
      title: "Remontointi / Renovation",
      description: "Maalaus ja uudistustyöt / Painting & remodeling work",
      alt: "Professional renovation team painting modern apartment"
    }
  ];

  return (
    <section className="py-20 bg-gradient-subtle" id="gallery">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Galleria
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Katso esimerkkejä laadukkaasta työstämme
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryItems.map((item, index) => (
            <Card 
              key={item.id} 
              className="group overflow-hidden bg-card shadow-smooth hover:shadow-glow transition-smooth hover-scale animate-fade-in"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <CardContent className="p-0">
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-64 object-cover transition-smooth group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-smooth"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-smooth">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;